import { type Ref, ref, computed } from "vue";
import { graphGet } from "@/helpers/api/apiGraph";

export const useMyDriveComposable = () => {
  const myDriveRootIdString: Ref<string | null> = ref(null);
  const driveTypeMap: Ref<Record<string, string>> = ref({});

  const calculateDriveIdOrMyDrive = computed(() => (driveId: string | null | undefined) => {
    return driveId ? driveId : myDriveRootIdString.value;
  });

  const calculateRootOrDriveId = computed(() => (driveId: string | null | undefined) => {
    return driveId ? driveId : myDriveRootId.value;
  });

  const myDriveRootId = computed(() => myDriveRootIdString.value);

  const driveType = computed(() => (driveId: string | null | undefined) => {
    const realDriveId = calculateRootOrDriveId.value(driveId);
    return driveTypeMap.value[realDriveId as string];
  });

  const loadMyOneDriveRoot = async () => {
    if (import.meta.env.VITE_BUILD_TARGET === "kkfiler") {
      return;
    }
    if (!myDriveRootIdString.value) {
      try {
        const response = await graphGet("/me/drive");
        myDriveRootIdString.value = response.id;
        driveTypeMap.value[response.id] = "OneDrive";
        // eslint-disable-next-line no-empty
      } catch {}
    }
  };

  return {
    myDriveRootIdString,
    driveTypeMap,
    calculateDriveIdOrMyDrive,
    calculateRootOrDriveId,
    myDriveRootId,
    driveType,
    loadMyOneDriveRoot
  };
};
